<div class="row minicart-comp">
  <div class="component col-12 mb-2 CartSelector">
    @if (cartsList$ | async; as cartsList) {
      <div class="position-relative">
        <div class="current-cart-wrapper">
          <div class="current-cart-btn" (click)="navigateToCart()">
            @if (cartsList?.carts?.length > 0) {
              <div>
                <div class="header-cart">
                  {{cartsList?.carts?.at(0)?.name ? cartsList?.carts[0].name : ("homePageHeader.newCart" | cxTranslate)}}
                </div>
                <div>
                  {{cartsList?.carts?.at(0)?.totalItems === 0
                  ? ("homePageHeader.emptyCart" | cxTranslate)
                  : (cartsList?.carts[0].totalItems+" "+("homePageHeader.itemsInCart" | cxTranslate))
                  }}
                </div>
              </div>
            } @else {
              <div>{{"homePageHeader.newCart" | cxTranslate}}</div>
              <div>{{"homePageHeader.emptyCart" | cxTranslate}}</div>
            }
          </div>
          <div class="current-cart-toggle-dropdown d-flex justify-content-center align-items-center" (click)="toggle()">
            <i [ngClass]="toggleCarts ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" style="font-size: 1.3em"></i>
          </div>
        </div>
        @if (toggleCarts) {
          <div class="switch-cart-dropdown">
            @for (cart of cartsList?.carts?.slice(1, 5); track cart; let i = $index) {
              <div class="switch-cart-item" (click)="changeCart(i)">
                <div class="d-flex">
                  <div class="item-icon">
                    <i class="fa fa-shopping-cart"></i>
                  </div>
                  <div class="item-text">
                    <div class="item-text-heading">
                      {{cart.name ? cart.name : ("homePageHeader.newCart" | cxTranslate)}}
                    </div>
                    <div>
                      {{
                      cart?.totalItems === 0
                      ? ("homePageHeader.emptyCart" | cxTranslate)
                      : (cart?.totalItems+" "+("homePageHeader.itemsInCart" | cxTranslate))
                      }}
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="switch-cart-controls">
              <div class="switch-cart-item" (click)="onNewCartClick()">
                <div class="d-flex">
                  <div class="item-icon">
                    <i class="fa fa-cart-plus"></i>
                  </div>
                  <div class="item-text">
                    <div>{{"homePageHeader.newCart" | cxTranslate}}</div>
                  </div>
                </div>
              </div>
              <div class="switch-cart-item" (click)="onManageCartsClick()">
                <div class="d-flex">
                  <div class="item-icon">
                    <i class="fa fa-ellipsis-h"></i>
                  </div>
                  <div class="item-text">
                    <div>{{"homePageHeader.manageCarts" | cxTranslate}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="position-relative">
        <div class="current-cart-wrapper">
          <div class="current-cart-btn custom-flex-center">
            <span class="mr-2">{{"homePageHeader.loading" | cxTranslate}}</span>
            <i class="pi pi-spin pi-spinner mini-cart-spinner"></i>
          </div>
          <div class="current-cart-toggle-dropdown d-flex justify-content-center align-items-center">
            <i class="pi pi-chevron-down" style="font-size: 1.3em"></i>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<!-- Create New Cart Modal -->
<p-dialog [(visible)]="showNewCartModal" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  styleClass="cstm-dialog" [draggable]="false" [resizable]="false" (onHide)="onCloseNewCartModal()" [focusTrap]="false"
  [dismissableMask]="true">
  <ng-template pTemplate="header">
    <h4 class="m-0">{{"homePageHeader.newCart" | cxTranslate}}</h4>
  </ng-template>
  <ng-template pTemplate="content">
    <p>{{"homePageHeader.creatingCart" | cxTranslate}}</p>
    <form class="col-lg-12 p-0" [formGroup]="newCartPopupForm">
      <div class="form-row">
        <div class="form-group col-lg-12">
          <label class="request-label required" for="cartName">
            {{"homePageHeader.cartName" | cxTranslate}}
          </label>
          <input type="text" formControlName="cartName" class="form-control request-data" />
        </div>
        <div class="form-group col-lg-12">
          <label class="request-label required" for="legalEntity">
            {{"homePageHeader.legalEntities" | cxTranslate}}
          </label>
          <p-dropdown formControlName="legalEntity" [filter]="true" [options]="legalEntityList"
            [styleClass]="(legalEntity?.invalid && legalEntity?.touched) ? 'border-red-500 cstm-dropdown' : 'cstm-dropdown'">
          </p-dropdown>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <p-button label="{{'homePageHeader.cancel' | cxTranslate}}" styleClass="btn cstm-btn-light"
      (onClick)="showNewCartModal=false"></p-button>
      <p-button label="{{'homePageHeader.create' | cxTranslate}}" styleClass="btn cstm-btn-primary ml-3"
      (onClick)="onNewCartConfirm();"></p-button>
    </div>
  </ng-template>
</p-dialog>